// Dependency
import React, { useState, useEffect } from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import UtilsService from "../../../services/utils.service";

// Internationalization
import { useTranslation } from "react-i18next";

// Styles
import * as mobileMenuStyles from './mobilemenu.module.scss';
import MenuTree from "./menuTree";
import { Sheet, SheetTrigger, SheetContent, SheetClose } from "../../sheet";
import * as headerStyles from '../header.module.scss'


// Template
const MobileMenu = ({ direction, country }) => {

    const data = useStaticQuery(graphql`
        query {
            datoCmsHeader{
                menuTrees {
                    tree {
                        _allNameLocales {
                            locale
                            value
                        }
                        _allUrlLocales {
                            locale
                            value
                        }
                        url
                        name
                    }
                    _allTitleLocales {
                        locale
                        value
                    }
                    title
                    link{
                        slug
                    }
                }
              
                mobileTopLink{
                    _allNameLocales {
                        locale
                        value
                    }
                    _allUrlLocales {
                        locale
                        value
                    }
                }
                _allMobileMenuLocales{
                 value{
                   name
                   url
                   locale
                   newWindow
                   showMegaNav
                 }
                 locale
               }
               darkLogo{
                    fixed( height: 16){
                        ...GatsbyDatoCmsFixed
                    }
                }
                mobileMenu{
                    _allNameLocales {
                        locale
                        value
                    }
                    _allUrlLocales {
                        locale
                        value
                    }
                    newWindow
                    thumbnail{
                        fluid{
                            ...GatsbyDatoCmsFluid
                        }
                    }
                }
                supportMenu{
                    _allNameLocales {
                        locale
                        value
                    }
                    _allUrlLocales {
                        locale
                        value
                    }
                    newWindow
                     thumbnail{
                        fluid{
                            ...GatsbyDatoCmsFluid
                        }
                    }
                }
                aboutMenu{
                    _allNameLocales {
                        locale
                        value
                    }
                    _allUrlLocales {
                        locale
                        value
                    }
                    newWindow
                     thumbnail{
                        fluid{
                            ...GatsbyDatoCmsFluid
                        }
                    }
                }
                socialMedia{
                    name
                    link
                }
                whiteLogo{
                    url
                }
                menuLinks{
                    name
                    url
                    thumbnail{
                        url
                    }
                    newWindow
                    showMegaNav
                }
                noticeMenu
                perks{
                    _allTextLocales {
                        locale
                        value
                    }
                }
                instagramText
                pages{
                    thumbnail{
                        fluid{
                            ...GatsbyDatoCmsFluid
                        }
                    }
                    _allUrlLocales {
                        locale
                        value
                    }
                    _allNameLocales {
                        locale
                        value
                    }
                }
                  smallPages{
                    thumbnail{
                        fluid{
                            ...GatsbyDatoCmsFluid
                        }
                    }
                    mobileThumbnail{
                        fluid{
                            ...GatsbyDatoCmsFluid
                        }
                    }
                    _allNameLocales {
                        value
                        locale
                    }
                    _allUrlLocales {
                        value
                        locale
                    }
                }
            }

        }
    `)
    const headerData = data.datoCmsHeader;


    const { t } = useTranslation();
    const locale = UtilsService.getLocaleFromUrl();
    const localeMap = UtilsService.localeMap;

    let mobileMenu = headerData._allMobileMenuLocales.filter((mobileMenuLocale) => {
        return mobileMenuLocale.locale === localeMap[country];
    });

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

    const { pathname } = typeof window !== 'undefined' ? window.location : '';

    useEffect(() => {
        setMobileMenuOpen(false)
      }, [pathname])
    
    return (
        <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
            <SheetTrigger className={`${headerStyles.cdHeaderItemMobile} ${headerStyles.cdHeaderItem}`}>
                <div className={`${headerStyles.cdHamburger}`}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </SheetTrigger>
            <SheetContent side={'left'} className="cd-moible-sheet">
                <div className={`${mobileMenuStyles.cdMobileMenuHeader} cd-dark-mode-border`}>
                    <Img loading="eager" fadeIn={false} className="cd-logo" fixed={headerData.darkLogo.fixed} />
                    <div className={mobileMenuStyles.cdMobileMenuHeaderItem}>
                        <SheetClose className={`${mobileMenuStyles.cdMobileMenuClose}`}>
                            <i className="material-icons">close</i>
                        </SheetClose>
                    </div>
                </div>
                <div className={mobileMenuStyles.cdMobileMenuContent}>
                    <div className={mobileMenuStyles.cdMobileMenuLinks}>

                        {headerData.menuTrees.map((menuTree, index) => {
                            return (
                                <MenuTree 
                                    closeParentSheet={(e) => setMobileMenuOpen(e)}
                                    country={country} 
                                    content={menuTree} 
                                    key={index}
                                />
                            )
                        })}
                        {mobileMenu[0].value.map((menuLink, index) => {
                            return (
                                <SheetClose  
                                    key={index}  
                                    asChild
                                >
                                    <Link
                                        className="cd-dark-mode-border"
                                    to={`/${country}${menuLink.url.includes('tb-open') ? menuLink.url : menuLink.url + '/'}`}
                                    >
                                        {menuLink.name}
                                    </Link>
                                </SheetClose>
                            )
                        })}
                    </div>
                    <div className={mobileMenuStyles.cdMobileMenuCollage}>
                        {headerData.smallPages && headerData.smallPages.map((collageLink, index) => {
                            let linkName = collageLink._allNameLocales.filter((linkNameLocale) => {
                                return linkNameLocale.locale === localeMap[country];
                            });

                            let linkUrl = collageLink._allUrlLocales.filter((linkURLLocale) => {
                                return linkURLLocale.locale === localeMap[country];
                            });
                            return (
                                linkUrl[0].value?.includes('https') ? <a key={index} target="_blank" rel="noreferrer" className={`cd-background-img`} href={linkUrl[0].value}>{collageLink.thumbnail && <Img fluid={collageLink.thumbnail.fluid} alt="" />}<p>{linkName[0].value}</p></a> :
                                    <Link key={index} to={`/${locale.country}${linkUrl[0].value}`} className={`cd-background-img`}>
                                        {collageLink.thumbnail && <Img fluid={collageLink.thumbnail.fluid} alt="" />}
                                        <div className="cd-background-overlay"></div>
                                        <p>{linkName[0].value}</p>
                                    </Link>
                            )
                        })}
                    </div>
                </div>
            </SheetContent>
        </Sheet>
    );
};

export default MobileMenu;